module.exports = __webpack_public_path__ + "static/media/banner-bg.e457b9b1.jpg";